import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisOnboardingRoute: InvariantJiraRoute = {
	name: 'polaris-onboarding',
	path: '/welcome/discovery',
	exact: true,
};
